module.exports = __webpack_public_path__ + "img/logo-mq.6b11beb2.png";